export default __webpack_public_path__ + "static/media/34.ee775688.jpg";